import * as React from 'react';
import { sanitizeHTML } from './sanitizeHTML';
export const SanitizeInnerHTMLWrapper = _ref => {
  let children = _ref.children,
    innerHtml = _ref.innerHtml;
  return /*#__PURE__*/React.cloneElement(children, {
    dangerouslySetInnerHTML: {
      __html: sanitizeHTML(innerHtml)
    }
  });
};
//# sourceMappingURL=SanitizeInnerHTMLWrapper.js.map